<template>
  <div>
    <!-- service_area_start -->
    <div class="service_area">
      <div 
      :class="this.$router.history.current['path'] == '/fr/service' || this.$router.history.current['path'] == '/en/service' || this.$router.history.current['path'] == '/service' ? 'show_wave' : ''"
      class='service-wave' style="height: 200px; overflow: hidden;" ><svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;"><path d="M0.00,49.98 C149.99,150.00 271.49,-49.98 500.00,49.98 L500.00,0.00 L0.00,0.00 Z" style="stroke: none; fill: #ffff;"></path></svg></div>
      <div class="container">
        <div class="row">
          <div data-aos="fade-up" class="col-xl-12">
            <div class="section_title2 text-center mb-90">
              <i class="flaticon-scissors"></i>
              <h3>{{ $t("service.name") }}</h3>
            </div>
          </div>
        </div>
        <div data-aos="fade-up" data-aos-duration="1000" class="white_bg_pos">
          <div class="row">
              <div
                data-aos="fade-up"
                class="single_service d-flex col-md-6 col-xl-6 justify-content-between align-items-center"
                v-for="(service,index) in services"
                :key="index"
              >
                <div class="service_inner d-flex align-items-center">
                  <div class="thumb">
                    <img :src="service.img" alt="Barbershop Agadir | salon de coiffure Agadir | صالون حلاقة" />
                  </div>
                  <span>{{service.name}}</span>
                </div>
                <p>………………………. {{service.price}} DH</p>
              </div>
         
            <div class="col-xl-12">
              <div class="book_btn text-center">
                <a
                  data-aos="fade-up"
                  @click="$store.commit('toggleActive')"
                  class="boxed-btn3 popup-with-form"
                  >{{ $t("nav.appointment") }}</a
                >
              </div>
            </div>
          </div>
        </div>
        
      </div>

    </div>
    <!-- service_area_end -->
    <Barbers
      v-if="this.$router.history.current['path'] == '/fr/service' || this.$router.history.current['path'] == '/en/service' || this.$router.history.current['path'] == '/service'"
    ></Barbers>
  </div>
</template>
<script>
import Barbers from "./layout/barbers.vue";
import img1 from '../img/service/1.png';
import img2 from '../img/service/2.png';
import img3 from '../img/service/3.png';
import img4 from '../img/service/4.png';
import img5 from '../img/service/5.png';
import img6 from '../img/service/6.png';


export default {
  data() {
    return {
      services:[
        {
          img:img1,
          name:'Soins du visage',
          price:'70'
        },
        {
          img:img2,
          name:'Kératine',
          price:'200'
        },
        {
          img:img3,
          name:'Teinture pour cheveux',
          price:'200'
        },
        {
          img:img4,
          name:'Lasir',
          price:'20'
        },
         {
          img:img5,
          name:'Rasé tes cheveux',
          price:'30'
        },
         {
          img:img6,
          name:'Barbu rasé',
          price:'15'
        },

        
      ]
    };
  },

  components: {
    Barbers,
  },
};
</script>

<style lang="scss">
@import "../styles/_responsive.scss";
@import "../styles/_mixins.scss";
@import "../styles/_varriable.scss";
@import "../styles/_reset.scss";
@import "../styles/_bradcam.scss";
@import "../styles/_btn.scss";
@import "../styles/_section_title.scss";
@import "../styles/pages/_service.scss";
@import "../styles/font/flaticon.css";
@import "../styles/font/flaticon.css";
.service-wave{
    height: 150px;
    overflow: hidden;
    position: absolute;
    width: 100%;
    top: 0px;
    @media #{$mobile_device} {
        height: 100px !important;
    }
    &.show_wave{
      display: none;
    }
}

</style>